import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthGuard } from '@readsavor/auth';
import { ROUTES } from './routes.js';

export const RouteAuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();

  const handleUnauthenticated = () => {
    // 用户未认证，重定向到登录页
    navigate(ROUTES.LOGIN.path);
  };

  return <AuthGuard onUnauthenticated={handleUnauthenticated}>{children}</AuthGuard>;
};
